import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import type { ParameterRange } from "@/shared/parameter-range";
import { isObject } from "@/shared/utils/typeGuards";

export const kBlend30Route = "/blend-3.0";

// A single symmetric knob: 0 = audio A's timbre over audio B's structure,
// 1 = the mirror image, 0.5 = a maximal 50/50 blend seeded from fresh noise.
export const kBlendValueRange: ParameterRange = { min: 0, max: 1, default: 0.5 };

export interface Blend30RequestBody {
    audioAKey: string;
    audioBKey: string;
    bpmA: number;
    bpmB: number;
    blendValue?: number;
}

export const isBlend30RequestBody = (value: unknown): value is Blend30RequestBody =>
    isObject(value) &&
    typeof value.audioAKey === "string" &&
    typeof value.audioBKey === "string" &&
    typeof value.bpmA === "number" &&
    typeof value.bpmB === "number";

export const kBlend30Endpoint: ApiEndpoint<Blend30RequestBody, DownloadUrlResponse> = {
    route: kBlend30Route,
    label: "Blend 3.0",
    source: "Modal",
    category: "SpliceGen v3.0",
    description:
        "Blends two audio loops along a single symmetric knob using the SpliceGen 3.0 model, trading timbre against structure between the two sources.",
    isRequestBody: isBlend30RequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
